<template>
  <Dialog
    width="860px"
    :height="createRenderType == 'mobile' ? 'unset' : 'unset'"
    titleAlign="left"
    :title="$$t('editor.trim')"
    v-model:visible="renderData.visible"
    @close="closeDialog"
    :background="
      createRenderType == 'mobile' && !props.item?.song_id
        ? 'linear-gradient(180deg, rgba(123, 237, 255, 0.3) 0%, rgba(123, 237, 255, 0) 100%), black'
        : null
    "
    mobileRenderType="drawerDialog"
    :customClass="`trim-editing-dialog ${
      createRenderType == 'mobile' ? 'trim-editing-dialog--mobile' : ''
    }`"
  >
    <div
      class="trim-editing-dialog-container"
      :class="{
        [`trim-editing-dialog-container--${createRenderType}`]: true,
      }"
    >
      <div class="trim-editing-dialog-edit-box">
        <div class="trim-editing-dialog-media-box">
          <div
            class="trim-editing-dialog-media-upload"
            v-if="renderData.editMode == 'upload'"
          >
            <AudioDragUpload
              pointTypePrefix="trim_editing"
              :uploadDescription="$$t('editor.trim_editing_description')"
              @initEditData="doInitEditData"
              @syncUploadState="doSyncUploadState"
            ></AudioDragUpload>
          </div>
          <div
            class="trim-editing-dialog-media-processing"
            v-if="renderData.editMode == 'processing'"
          >
            <div class="redm-processing-loading-box">
              <div class="redm-processing-loading rotate-loading"></div>
              <div class="redm-processing-loading-ico flex-center">
                <i class="icon"> </i>
              </div>
            </div>
            <div class="trim-editing-dialog-media-processing-text">
              {{ $$t("editor.audio_edit_data_processing") }}
            </div>
          </div>
          <div
            class="trim-editing-dialog-media-processfailed"
            v-if="renderData.editMode == 'processfailed'"
          >
            <div class="region-processing-processfailed-ico"></div>
            <div class="trim-editing-dialog-media-processfailed-text tc">
              {{ $$t("editor.get_editing_data_failed") }}
            </div>
            <div class="trim-editing-dialog-media-processfailed-button">
              <div
                class="trim-editing-dialog-media-processfailed-button-item"
                v-if="!props.item?.song_id"
              >
                <Button
                  @click="onCancelClick"
                  :renderStyle="{
                    '--padding': '0',
                    '--width': '100%',
                    '--height': '32px',
                    '--borderRadius': '48px',
                    '--background': 'rgba(255, 255, 255, 0.2)',
                    '--fontColor': '#fff',
                    '--fontSize': '14px',
                    '--fontWeight': 'normal',
                    '--border': 'none',
                    '--backgroundHover': 'rgba(255, 255, 255, 0.3)',
                    '--fontColorHover': '#fff',
                  }"
                >
                  <span class="fn-inline">{{ $$t("create.cancel") }}</span>
                </Button>
              </div>
              <div class="trim-editing-dialog-media-processfailed-button-item">
                <Button
                  @click="onRetryClick"
                  :renderStyle="{
                    '--padding': '0',
                    '--width': '100%',
                    '--height': '32px',
                    '--borderRadius': '48px',
                    '--background': 'rgba(255, 255, 255, 0.2)',
                    '--fontColor': '#fff',
                    '--fontSize': '14px',
                    '--fontWeight': 'normal',
                    '--border': 'none',
                    '--backgroundHover': 'rgba(255, 255, 255, 0.3)',
                    '--fontColorHover': '#fff',
                  }"
                >
                  <span class="fn-inline">{{ $$t("create.retry") }}</span>
                </Button>
              </div>
            </div>
          </div>

          <div
            class="trim-editing-dialog-media-edit"
            v-if="renderData.editMode == 'editing'"
          >
            <EditSelectAudio
              ref="refEditSelectAudio"
              type="select"
              :url="renderData.audioUrl"
              :duration="renderData.audioDuration"
              :waveformData="renderData.waveformData"
              :hideRemove="renderData.hideRemove"
              @syncSelectData="doSyncSelectData"
              @syncSelectedData="doSyncSelectedData"
              @remove="doRemove"
              @selectChangeLimit="doSelectChangeLimit"
              v-model:disabledTrim="renderData.disabledTrim"
              v-model:disabledReset="renderData.disabledReset"
            ></EditSelectAudio>
          </div>
        </div>
      </div>
      <div
        class="trim-editing-dialog-button-box flex"
        v-if="renderData.editMode == 'editing'"
      >
        <div class="trim-editing-dialog-button-box-left flex">
          <div class="trim-button-box trim-editing-dialog-button">
            <Button
              @click="onTrimClick"
              :disabled="disabledSubmit || renderData.disabledTrim"
              :renderStyle="{
                '--padding': '0',
                '--width': '100%',
                '--height': '48px',
                '--borderRadius': '48px',
                '--background': 'rgba(255, 255, 255, 1)',
                '--fontColor': '#000',
                '--fontSize': '16px',
                '--fontWeight': '500',
                '--border': 'none',
                '--backgroundHover': 'rgba(255, 255, 255, 0.75)',
                '--fontColorHover': '#000',
              }"
            >
              <i class="fn-inline button-ico button-ico-trim"></i>
              <span class="fn-inline">{{ $$t("editor.trim") }}</span>
            </Button>
          </div>
          <div class="reset-button-box trim-editing-dialog-button">
            <Button
              @click="onResetClick"
              :disabled="disabledSubmit || renderData.disabledReset"
              :renderStyle="{
                '--padding': '0',
                '--width': '100%',
                '--height': '48px',
                '--borderRadius': '48px',
                '--background': 'rgba(255, 255, 255, 1)',
                '--fontColor': '#000',
                '--fontSize': '16px',
                '--fontWeight': '500',
                '--border': 'none',
                '--backgroundHover': 'rgba(255, 255, 255, 0.75)',
                '--fontColorHover': '#000',
              }"
            >
              <i class="fn-inline button-ico button-ico-reset"></i>
              <span class="fn-inline">{{ $$t("editor.reset") }}</span>
            </Button>
          </div>
        </div>
        <div
          class="submit-button-box trim-editing-dialog-button trim-editing-dialog-button-box-right"
        >
          <div class="reset-button-box trim-editing-dialog-button">
            <Button
              :disabled="disabledSubmit || renderData.disabledReset"
              :loading="renderData.loadingSubmit"
              @click="onSubmitClick"
              :renderStyle="{
                '--padding': '0',
                '--width': '100%',
                '--height': '48px',
                '--borderRadius': '48px',
                '--background':
                  'linear-gradient(100deg, #4FDEFF -2%, #E675FF 100%)',
                '--fontColor': '#fff',
                '--fontSize': '16px',
                '--fontWeight': '500',
                '--border': 'none',
                '--backgroundHover':
                  'linear-gradient(100deg, #4FDEFF -2%, #E675FF 100%)',
                '--fontColorHover': '#fff',
              }"
            >
              {{ $$t("create.done") }}
            </Button>
          </div>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
  getCurrentInstance,
} from "vue"

import { useRouter, useRoute } from "vue-router"
import globalConfig, { chinaAppName } from "@/config/config.js"

import apiEditor from "@/api/api/apiEditor.js"
import apiCommon from "@/api/api/apiCommon.js"

import { showActionDialog } from "@/components/functionCallComponent/action/action.js"

import AudioDragUpload from "../component/audioDragUpload.vue"
import ToggleEditLyrics from "../component/toggleEditLyrics.vue"
import CreditsButton from "../component/creditsButton.vue"
import AddLinkDialog from "../component/addLinkDialog.vue"
import Button from "@/components/basic/button/Button.vue"
import EditSelectAudio from "../component/editSelectClipAudio.vue"

import tools from "@/utils/tools.js"
import ffmpegUtil from "@/components/media/utils/ffmpegUtil.js"
import message from "@/components/functionCallComponent/message.jsx"
import clipUtil from "@/components/media/utils/clipUtil.js"
import objectStorage, {
  getObjectStorageFullUrl,
} from "@/lib/objectStorage/objectStorage.js"

import { storeToRefs } from "pinia"
import useCreateLayoutStore from "@/store/create/createLayoutStore.js"
import useUserDataStore from "@/store/userDataStore.js"
import useFeedListStore from "@/store/create/feedListDataStore.js"
const { $$language, $$t, $$tm, $$tValue } = getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {}

const createLayoutStore = useCreateLayoutStore()
const userDataStore = useUserDataStore()
const { createRenderType } = storeToRefs(createLayoutStore)
const feedListDataStore = useFeedListStore()

const Router = useRouter()
const route = useRoute()

const globalProperties =
  getCurrentInstance()?.appContext.config.globalProperties

const props = defineProps({
  pitem: {
    type: Object,
    default: null,
  },
  item: {
    type: Object,
    default: null,
  },
  visible: {
    type: Boolean,
    default: false,
  },
})

const refToggleEditLyrics = ref(null)
const emits = defineEmits(["update:visible"])

const stateData = {
  parseDataParams: null,
  lyricUnitTimeDataArray: [],
}

const refEditSelectAudio = ref(null)

const renderData = reactive({
  visible: props.visible,
  editMode: "upload", // "upload", "processing","editing", "processfailed"
  addLinkDialogVisible: false,
  hideRemove: props.item?.song_id ? true : false,
  linkParseUrl: "",
  file: null,
  linkUrl: "",
  clipSourceData: null,
  editFileName: "",
  audioUrl: "", // https://test.mureka.ai/cos-test/song/audio/20250213/music_56098979577857_PfJV1K6VMYcGNNWnzYropf_bcfiec.mp3",
  audioDuration: 160.183,
  waveformData: Array.from(
    {
      length: 1000,
    },
    (v, i) => Math.random()
  ),
  lyric: "",
  lyricMaxLength: 100,
  loadingSubmit: false,
  disabledTrim: false,
  disabledReset: false,
  membership_source: {
    membership_source1: props.item?.song_id ? "membership_feature" : "editor",
    membership_source2: props.item?.song_id ? "regenerate" : "trim_editing",
  },
  from: 0,
  to: 0,
  duration: 0,
  lastTrimData: null,
})

const disabledSubmit = computed(() => {
  return renderData.editMode !== "editing"
})

const doDownloadFile = async (url, filename) => {
  return new Promise((resolve, reject) => {
    var xhr = new XMLHttpRequest()
    xhr.open("GET", url, true)
    xhr.responseType = "blob"
    xhr.onload = function (e) {
      if (this.status === 200) {
        var blob = new Blob([this.response], {
          type: this.response?.type || "text/plain",
        })
        const resfile = new File([blob], filename, { type: blob.type })
        resolve(resfile)
      } else {
        reject(this.statusText)
      }
    }
    xhr.send()
  })
}

const closeDialog = () => {
  if (renderData.editMode === "editing") {
    showActionDialog({
      content: $$t("editor.edit_close_warning"),
      cancelLabel: $$t("editor.keep"),
      confirmLabel: $$t("create.close"),
      titleAlign: "center",
      confirm: (closeAction) => {
        closeAction()
        renderData.visible = false
      },
    })
  } else {
    renderData.visible = false
  }
}

const doSyncSelectData = async (data) => {
  renderData.from = data.from
  renderData.to = data.to
  renderData.duration = data.duration
}
const doSyncSelectedData = async (data) => {
  renderData.lastTrimData = data
}

const doSelectChangeLimit = (data) => {
  if (["area"].includes(data)) {
    message.info({
      content: $$tValue("editor.trim_editing_select_limit_area_warning", {
        duration: 30,
      }),
    })
  }
}

const doRemove = async () => {
  showActionDialog({
    content: $$t("editor.edit_remove_warning"),
    cancelLabel: $$t("editor.keep"),
    confirmLabel: $$t("create.delete"),
    titleAlign: "center",
    confirm: (closeAction) => {
      closeAction()
      renderData.editMode = "upload"
      renderData.lyric = ""
      renderData.lyricSource = ""
      renderData.from = 0
      renderData.to = 0
      stateData.lyricUnitTimeDataArray = []
    },
  })
}

const doSyncUploadState = () => {}

const doInitEditData = async (data) => {
  renderData.editMode = "processing"
  doParseInitEditData(data)
}

const doParseInitEditData = (data) => {
  renderData.editMode = "processing"
  stateData.parseDataParams = {
    resource: data.linkUrl,
    source_type: data.source_type,
    cos_url: data?.cos_url,
    duration_milliseconds: data?.duration_milliseconds,
    title: data?.title,
    is_need_waves: true,
    is_need_lyrics: true,
    check_mute_duration: false,
  }
  return new Promise((resolve, reject) => {
    apiEditor
      .parseAudioData(stateData.parseDataParams)
      .then((res) => {
        if (res.code == 200) {
          renderData.waveformData = res.data.waves
          renderData.audioDuration = res.data.duration_milliseconds / 1000
          renderData.audioUrl =
            getObjectStorageFullUrl(res.data.mp3_url) + "?type=extendEditing"
          renderData.title = res.data.title
          renderData.editMode = "editing"
          stateData.parseResData = res.data
        } else {
          if (res.code == 6346) {
            message.error({
              content: $$t("editor.check_mute_duration_warning"),
              positon: "top",
            })
            onCancelClick()
          } else if (res.code == 6316) {
            message.error({
              content: $$t("create.song_state_auditing_failed"),
              positon: "top",
            })
            onCancelClick()
          } else {
            message.error({
              content: $$t("editor.get_editing_data_failed_message"),
              positon: "top",
            })
            renderData.editMode = "processfailed"
          }
        }
      })
      .catch((err) => {
        message.error({
          content: $$t("editor.get_editing_data_failed_message"),
          positon: "top",
        })
        renderData.editMode = "processfailed"
        reject(err)
      })
  })
}

const doParseInitEditDataWithSong = () => {
  renderData.editMode = "processing"
  return new Promise((resolve, reject) => {
    apiCommon
      .getSongInfo({ song_id: props.item.song_id, check_mute_duration: true })
      .then((res) => {
        if (res.code == 200) {
          renderData.waveformData = res.data.waves
          renderData.audioDuration = res.data.duration_milliseconds / 1000

          renderData.audioUrl =
            getObjectStorageFullUrl(res.data.mp3_url) + "?type=extendEditing"
          renderData.title = res.data.title
          renderData.editMode = "editing"
          stateData.parseResData = res.data
        } else {
          if (res.code == 6346) {
            message.error({
              content: $$t("editor.check_mute_duration_warning"),
              positon: "top",
            })
            renderData.editMode = "processfailed"
          } else if (res.code == 6316) {
            message.error({
              content: $$t("create.song_state_auditing_failed"),
              positon: "top",
            })
            renderData.editMode = "processfailed"
          } else {
            message.error({
              content: $$t("editor.get_editing_data_failed_message"),
              positon: "top",
            })
            renderData.editMode = "processfailed"
          }
        }
      })
      .catch((err) => {
        renderData.editMode = "processfailed"
        reject(err)
      })
  })
}

const onRetryClick = () => {
  if (props.item) {
    doParseInitEditDataWithSong()
  } else {
    doParseInitEditData(stateData.parseDataParams)
  }
}
const onTrimClick = () => {
  refEditSelectAudio.value?.trimSelectData()
}
const onResetClick = () => {
  refEditSelectAudio.value?.reset()
}

const onCancelClick = () => {
  renderData.editMode = "upload"
  renderData.lyric = ""
  renderData.lyricSource = ""
  renderData.from = 0
  renderData.to = 0
  stateData.lyricUnitTimeDataArray = []
}

const onSubmitClick = () => {
  globalProperties.logCustomEvent("trim_editing_button_click", {
    tab_stare: "trim_editing",
    content_id: props.item?.song_id,
    source: props.item?.song_id
      ? "mysong"
      : stateData.parseDataParams?.source_type == 1
      ? "youtube_link_upload"
      : "file_upload",
  })
  renderData.loadingSubmit = true
  feedListDataStore
    .doTrimEditSongDoneReGenerate(
      {
        parent_song_id: props.item?.song_id,
        start_milliseconds: Math.min(
          Math.floor(renderData.lastTrimData.from * 1000),
          stateData.parseResData?.duration_milliseconds
        ),
        end_milliseconds: Math.min(
          Math.floor(renderData.lastTrimData.to * 1000),
          stateData.parseResData?.duration_milliseconds
        ),
        title: renderData.title,
        generation_method: 9,
        is_generated_from_uploaded_file: !props.item?.song_id,
        outer_song: props.item?.song_id
          ? null
          : {
              id: stateData.parseResData?.id,
            },
      },
      renderData.membership_source
    )
    .then(() => {
      renderData.loadingSubmit = false
      renderData.visible = false
    })
    .catch((err) => {
      renderData.loadingSubmit = false
    })
}

const init = async () => {
  if (props.item) {
    doParseInitEditDataWithSong()
  }
}

const poninterEvent = () => {
  if (renderData.visible) {
    if (props.item) {
      globalProperties.logCustomEvent("create_audio_edit_tab_stare_show", {
        tab_stare: "trim_editing",
        content_id: props.item?.song_id,
      })
    } else {
      globalProperties.logCustomEvent("create_audio_edit_tab_stare_show", {
        tab_stare: "trim_editing",
      })
    }
  }
}
watch(
  () => {
    return props.visible
  },
  () => {
    renderData.visible = props.visible
    poninterEvent()
  }
)
watch(
  () => {
    return renderData.visible
  },
  () => {
    emits("update:visible", renderData.visible)
  }
)

onMounted(() => {
  init()
  poninterEvent()
})
</script>
<style lang="scss">
.trim-editing-dialog-container {
  padding: 13px 40px 40px 40px;
  height: 100%;
  display: flex;
  flex-direction: column;
  .trim-editing-dialog-edit-box {
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 0;

    .trim-editing-dialog-media-box {
      border-radius: 16px;
      background: rgba(148, 173, 255, 0.2);
    }
  }
  .trim-editing-dialog-media-processing {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 196px;
    padding: 20px 0 16px 0;
    .redm-processing-loading-box {
      width: 100px;
      height: 100px;
      position: relative;

      .redm-processing-loading {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background: conic-gradient(
          from 180deg at 50% 50%,
          rgba(148, 173, 255, 0.28) 0deg,
          rgba(148, 173, 255, 0.8) 54deg,
          rgba(148, 173, 255, 0.2) 95deg,
          rgba(148, 173, 255, 0.1) 136deg,
          rgba(148, 173, 255, 0.28) 178deg,
          rgba(148, 173, 255, 0.8) 236deg,
          rgba(148, 173, 255, 0.2) 279deg,
          rgba(148, 173, 255, 0.1) 321deg,
          rgba(148, 173, 255, 0.28) 360deg,
          rgba(148, 173, 255, 0.8) 414deg
        );
        animation: animation-rotate-infinite 0.75s infinite normal linear;
      }
      .redm-processing-loading-ico {
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        i {
          height: 100%;
          width: 100%;
          background: url(@/assets/img/editor/upload-drag-loading-ico.png);
          background-size: 100% 100%;
        }
      }
    }
    .trim-editing-dialog-media-processing-text {
      font-family: HarmonyOS Sans SC;
      font-size: 14px;
      font-weight: normal;
      line-height: normal;
      color: #ffffff;
      margin: 16px 0 0 0;
    }
  }
  .trim-editing-dialog-media-processfailed {
    padding: 19px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .region-processing-processfailed-ico {
      height: 80px;
      width: 80px;
      background: url(@/assets/img/editor/upload-processing-failed-ico.png);
      background-size: 100% 100%;
    }
    .trim-editing-dialog-media-processfailed-text {
      font-family: HarmonyOS Sans SC;
      font-size: 16px;
      font-weight: normal;
      line-height: 22px;
      color: #ffffff;
      margin: 12px 12px;
    }
    .trim-editing-dialog-media-processfailed-button {
      display: flex;
      justify-content: center;
      align-items: center;
      .trim-editing-dialog-media-processfailed-button-item {
        width: 140px;
        &:last-child {
          margin: 0 0 0 10px;
        }
      }
    }
  }
  .trim-editing-dialog-media-edit {
    height: 162px;
  }
  .trim-editing-dialog-button-box {
    margin: 20px 0 0 0;
    justify-content: space-between;
    .trim-editing-dialog-button-box-left {
      .trim-editing-dialog-button {
        width: 160px;
        &:last-child {
          margin: 0 0 0 8px;
        }
      }
    }
    .trim-editing-dialog-button-box-right {
      width: 280px;
    }
    .button-ico {
      height: 18px;
      width: 18px;
      margin: 0 4px 0 0;
    }
    .button-ico-trim {
      background: url(@/assets/img/editor/clip-ico-3x.png);
      background-size: 100% 100%;
    }
    .button-ico-reset {
      background: url(@/assets/img/editor/replace-ico-3x.png);
      background-size: 100% 100%;
    }
    .custom-button .el-button .el-icon.is-loading {
      background-image: url(@/assets/img/loading-mini-white-3x.png) !important;
      background-size: 100% 100% !important;
    }
  }
  &.trim-editing-dialog-container--mobile {
    padding: 13px 0 16px 0;

    .trim-editing-dialog-edit-box {
      overflow-y: auto;
      padding: 0 16px;
    }
    .trim-editing-dialog-media-processing {
      height: 174px;
      padding: 22px 0 16px 0;
      .redm-processing-loading-box {
        width: 80px;
        height: 80px;
      }
      .trim-editing-dialog-media-processing-text {
        font-size: 14px;
        line-height: 16px;
        margin: 12px 0 0 0;
      }
    }
    .trim-editing-dialog-media-processfailed {
      padding: 19px 0;
      .region-processing-processfailed-ico {
        height: 64px;
        width: 64px;
      }
      .trim-editing-dialog-media-processfailed-text {
        font-size: 14px;
        line-height: 16px;
        margin: 12px 12px;
      }
    }
    .trim-editing-dialog-media-edit {
      height: 160px;
    }
    .trim-editing-dialog-button-box {
      margin: 16px 16px 0 16px;
      justify-content: unset;
      flex-direction: column;
      .trim-editing-dialog-button-box-left {
        .trim-editing-dialog-button {
          width: 0;
          flex: 1;
          &:last-child {
            margin: 0 0 0 8px;
          }
        }
      }
      .trim-editing-dialog-button-box-right {
        margin: 16px 0 0 0;
        width: 100%;
      }
    }
  }
}
</style>
